// eslint-disable-next-line import/no-cycle
import { FragmentConfig } from './types';

/* eslint-disable prefer-destructuring */
const FRAGMENT_COMPANYID = process.env.FRAGMENT_COMPANYID || 'imwalkingde';
const FRAGMENT_HOST = process.env.FRAGMENT_HOST || 'emma.lan';
const FRAGMENT_NAMESPACE = process.env.FRAGMENT_NAMESPACE || 'fragment-cms';
const FRAGMENT_NAMESPACE_URL = process.env.FRAGMENT_NAMESPACE_URL || 'fragment-inspire-cms';
const FRAGMENT_CONTENT_NAMESPACE = process.env.FRAGMENT_CONTENT_NAMESPACE || 'fragment-content';
const NODE_ENV = process.env.NODE_ENV || '';
const BRANCH = process.env.BRANCH || 'master';
const CLUSTER_ENV = process.env.CLUSTER_ENV || 'production';
const CLUSTERTYPE = process.env.CLUSTERTYPE || 'current';
const confApiHost = `cloud-service-inspire-cms.${FRAGMENT_COMPANYID}.svc.cluster.local:3100`;
const replacePage = '::PAGE::';

const config: FragmentConfig = {
  global: {
    enabled: true,
    values: {
      FRAGMENT_HOST,
      FRAGMENT_COMPANYID,
      FRAGMENT_NAMESPACE,
      FRAGMENT_NAMESPACE_URL,
      FRAGMENT_CONTENT_NAMESPACE,
      NODE_ENV,
      BRANCH,
      CLUSTER_ENV,
      EPRIVACY_ENABLED: false,
      CLUSTERTYPE,
    },
  },
  renderer: {
    cache: {
      expiresMinutes: process.env.NODE_ENV === 'development' ? 0 : 15,
      expiresHours: 0,
    },
  },
  drupalIconMapper: {
    enabled: true,
    values: {
      ArrowLeft: 'ArrowLargeLeft',
      ArrowRight: 'ArrowLargeRight',
    },
  },
  companyIntershopMapper: {
    enabled: true,
    values: {
      imwalkingde: 'ImwalkingDE',
      baurde: 'BaurDE',
      ackermannch: 'AckermannCH',
      jelmolich: 'JelmoliCH',
      ottoversandat: 'OttoversandAT',
      quelleat: 'QuelleAT',
      quellech: 'QuelleCH',
      quellede: 'QuelleDE',
      universalat: 'UniversalAT',
      default: 'default',
    },
  },
  apiParams: {
    enabled: true,
    values: {
      apiDefaultParams: {
        channel: 'web',
        clientId: 'ImWalkingDe',
        clientShortId: 'iaw',
        locale: 'de-DE',
        localeApi: 'de',
        localesToSwitch: [],
        useNewApi: true,
      },
      apiAssetManagement: {
        path: 'https://media.imwalking.de',
      },
      apiRecoMagellan:
        '/suche/reco/magellan?clientId={REPLACE_CLIENTID}&type=WEIKATEC&datatype=json&maxCnt={REPLACE_MAX_COUNT}&filterValues=&locale={REPLACE_LOCALE_ISO}&method=CATEGORY&shopID={REPLACE_SHOP_ID}',
      apiRecoPrudsys:
        '/INTERSHOP/rest/WFS/EmpirieCom-{REPLACE_CLIENTID}-Site/web;loc={REPLACE_LOCALE_ISO};cur=EUR/fwd/ps40/{REPLACE_CLIENT_SHORT_ID}/plugins/exec/prudsys/prudsys/core/recommendation/{REPLACE_TYPE}?sid={REPLACE_SID}&locationid={REPLACE_LOCATION_ID}&userid={REPLACE_USER_ID}&tracking=true&cid={REPLACE_SHOP_ID}',
      apiCampaignEndPoint:
        'INTERSHOP/web/WFS/EmpirieCom-ImwalkingDE-Site/de_DE/web/EUR/PromotionNotification-Put',
    },
  },
  fetchParams: {
    enabled: true,
    values: {
      timeout: 5000,
      timeoutFallback: 10000,
    },
  },
  esiUrls: {
    enabled: true,
    values: {
      metaPath: `http://router.${FRAGMENT_HOST}/?emmaMode=true&metaData=true&noGtm=true`,
      headerPath: {
        'fr-CH': `http://${FRAGMENT_HOST}/fragment/header?isHP=true`,
        default: `http://${FRAGMENT_HOST}/fragment/header?isHP=true`,
      },
      footerEmma: `http://fragment-inspire-footer.${FRAGMENT_HOST}/`,
      footerLegacy: {
        'fr-CH': `http://router.${FRAGMENT_HOST}/fr/fragment/footer?noGtm=true`,
        default: `http://router.${FRAGMENT_HOST}/fragment/footer?noGtm=true`,
      },
      fragmentCommon: `http://fragment-common.${FRAGMENT_HOST}/`,
      homepageNewsletter:
        CLUSTERTYPE === 'next'
          ? undefined
          : `https://router.${FRAGMENT_HOST}/fragment/newsletter-homepage?noGtm=true&emmaMode=true`,
      homepageNewsletterLasche:
        CLUSTERTYPE === 'next'
          ? undefined
          : `http://router.${FRAGMENT_HOST}/fragment-nl-lasche/?emmaMode=true`,
      homepageNlLayer:
        CLUSTERTYPE === 'next'
          ? undefined
          : `http://router.${FRAGMENT_HOST}/landingpages/fragment-storefront-nl-promolayer/?emmaMode=true&noGtm=true`,
      minibanner:
        CLUSTERTYPE === 'next'
          ? undefined
          : `https://${FRAGMENT_HOST}/<locale>/landingpages/fragment-minibanner/`,
      promotionBanner: `http://fragment-inspire-promotion-banner.${FRAGMENT_HOST}/`,
      seoContent: `http://fragment-inspire-seo-content.${FRAGMENT_HOST}/<language>/toplinks/0`,
      serviceLayer: `http://fragment-content-external.${FRAGMENT_HOST}/servicelayer/<id>`,
    },
  },
  esiUrlHomepageMagazin: {
    enabled: false,
    values: {
      url: '',
    },
  },
  mediaBreakpoints: {
    enabled: true,
    values: {
      desktopMinWidth: '1025px',
      tabletMinWidth: '481px',
      tabletMaxWidth: '1024px',
      mobileMaxWidth: '480px',
    },
  },
  replace: {
    enabled: true,
    values: {
      page: replacePage,
    },
  },
  fontAdjustments: {
    headline: {
      size: {
        1: '2.625rem',
        2: '2.125rem',
        3: '1.625rem',
        4: '1.25rem',
        5: '1rem',
        6: '0.75rem',
      },
      lineheight: {
        1: '3.5rem',
        2: '2.5rem',
        3: '2rem',
        4: '1.5rem',
        5: '1.25rem',
        6: '1.25rem',
      },
      letterspacing: {
        1: '0',
        2: '0',
        3: '0',
        4: '0.5px',
        5: '0.5px',
        6: '0.5px',
      },
    },
  },
  currency: { sign: 'EUR', locale: 'de-DE' },
  headerInformation: {
    de: {
      description: '',
      title: '',
      canonical: '',
      robots: '',
    },
    fr: {
      description: '',
      title: '',
      canonical: '',
      robots: '',
    },
  },
  regExp: {
    flex: {
      justifyContent: new RegExp(
        /flex-start|flex-end|center|space-between|space-around|space-evenly/g,
      ),
      alignContent: new RegExp(/flex-start|flex-end|center|space-between|space-around|stretch/g),
      alignSelf: new RegExp(/stretch|flex-start|flex-end|center|baseline|auto/g),
    },
    textAlign: new RegExp(/left|right|center/g),
    eMail: {
      checkAt: new RegExp(/\b[\w.-]+@[\w.-]*\b/),
      checkProvider: new RegExp(/\b[\w.-]+@[\w.-]+\.\w{2,}\b/),
    },
  },
  apiCmsUrl: {
    enabled: true,
    environmentRelated: true,
    values: {
      url: `http://${confApiHost}/<localeApi>${replacePage}?_format=webapp_json&flat`,
    },
  },
  apiCmsUrlStaticPages: {
    enabled: true,
    environmentRelated: true,
    values: {
      url: `https://${FRAGMENT_HOST}/api/inspire/pages/<localeApi>/<page>.json`,
    },
  },
  apiCmsUrlFallback: {
    enabled: true,
    environmentRelated: true,
    values: {
      url: `https://${FRAGMENT_HOST}/fragment-cms/static-bucket/${FRAGMENT_COMPANYID}/<localeApi>${replacePage}.json`,
    },
  },
  apiCmsUrlPrefix: {
    enabled: true,
    environmentRelated: true,
    values: {
      url: `http://${confApiHost}`,
    },
  },
  routingPaths: {
    exact: '/',
    prefix: [
      '/storefront',
      '/inspire',
      '/emma-cms',
      '/preview',
      '/lp',
      '/fr/lp',
      '/service-hilfe',
      '/fr/service-hilfe',
      '/aide-service',
      '/fr/aide-service',
      '/fr/content',
      '/fr/content/service',
    ],
  },
  seoContent: {
    excludePages: ['/service-hilfe', '/aide-service', '/content', '/content/service'],
  },
  apiAgnitasUrl: {
    enabled: true,
    environmentRelated: true,
    values: {
      url: `https://agnitas-service.platform.empirie.${
        NODE_ENV === 'production' ? 'cloud' : 'dev'
      }/${FRAGMENT_COMPANYID}/v0`,
      useDOI: true,
    },
  },
  tracking: {
    schemaOrgOrganisation: {
      areaServed: 'DE',
      email: 'service@empirie.dev',
      hoursAvailable: 'täglich von 06:00 - 23:00 Uhr',
      logo: '/logo.svg',
      name: 'EMMA Shop',
      productSupported: '',
      sameAs: [],
      telephone: '',
      url: 'https://www.empirie.dev',
      potentialAction: {
        target: 'https://empirie.dev/s/',
      },
    },
    values: {
      brOutcomeUrl: '/defaultOutcomeUrl',
      googleSiteVerification: '',
      msvalidate01: '',
      siteName: '@defaultSitename',
      soastaId: '',
    },
  },
};

export default config;
